import TabOptions from '../options';

export class Model {
  items = [];
}
const options = new TabOptions(new Model());
options.preventTabChange = false;
options.preventBack = false;
options.preventRouteLeave = false;
options.keepUpdates = false;
export class Tab {
  id = 'Binnacle';
  title = 'Bitácora';
  model = new Model();
  valid = true;
  options = new TabOptions(new Model());
  build = (model) => {
    return {
      tab: this.id,
      ...model,
    };
  };
}
export default new Tab();
